
























import { computed, defineComponent } from '@vue/composition-api';

import { useFormat } from 'vivat';

const DeliveryNoteObject = defineComponent({
  props: {
    deliveryNote: {
      default: () => ({
        id: -1,
        uniqueId: '',
        status: 'PENDING',
        driver: {},
        deliveries: [],
      }),
    },
  },
  setup(props) {
    function formatToCurrency(number: string | number) {
      return useFormat.number(number).currency();
    }
    const toCurrency = (string: string) => parseFloat(string || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 });

    const deliveryNoteInformation = computed(() => {
      let weight = 0;
      let price = 0;
      let packagesPrice = 0;
      props.deliveryNote.deliveries.forEach((delivery: any) => {
        weight += delivery.totalWeight;
        price += delivery.deliveryFee;
        delivery.packages.forEach((item: any) => {
          packagesPrice += item.price;
        });
      });

      return {
        weight,
        price,
        packagesPrice,
      };
    });

    return {
      formatToCurrency,
      toCurrency,
      deliveryNoteInformation,
    };
  },
});

export default DeliveryNoteObject;
